import { TLicensingAuthorityType } from '@/shared/models/licensingAuthority';

type ValuesOf<T> = T[keyof T];

const FsmState = {
  newCar: '/join/new-vehicle',
  uploadNewCarDocs: '/join/new-vehicle?upload=car',
  doYouHaveCar: '/join/do-you-have-vehicle',
  driver: '/join/chauffeur',
  driverUpload: '/join/chauffeur?upload=driver',
  partnerPayments: '/join/payments',
  payTo: '/join/pay-to',
  payToUpload: '/join/pay-to?upload=legal',
  toDo: '/todo',
  welcome: '/join/welcome',
  licensingAuthority: '/join/licensing-authority',
  licensingAuthorityMissing: '/join/licensing-authority-missing',
  vehicle: '/join/vehicle',
} as const;

type TFsmState = ValuesOf<typeof FsmState>;

type TFsmEvent =
  | 'NEXT'
  | 'BACK'
  | 'SKIP'
  | 'UPLOAD'
  | 'UPLOAD_PERSONAL'
  | 'UPLOAD_LEGAL'
  | 'YES'
  | 'NO'
  | 'ADD_CAR'
  | 'VIEW_CAR'
  | 'EDIT_DRIVER'
  | 'TODO'
  | 'EDIT_PAYMENT_INFO'
  | 'EDIT_DRIVER_INFO';

type TFsmEffects =
  | 'PREPARE_CAR_FORM'
  | 'LOAD_CAR'
  | 'PREPARE_DRIVER_FORM'
  | 'RESET_CAR_FORM'
  | 'COMPLETE_ONBOARDING'
  | 'TRACK_CAR_SKIPPED_EVENT'
  | 'SCROLL_UP'
  | 'RELOAD_PARTNER';

interface IDraft {
  licensingAuthority?: TLicensingAuthorityType;
}

export { FsmState };
export type { TFsmState, TFsmEvent, TFsmEffects, IDraft };
